import React from "react";

import { useReportContext } from "../../report-context";

import { HeaderIcon } from "./HeaderIcon";

import { ReportColumn } from "@/types/evaluate";
import { cn } from "@/lib/utils";

interface HeaderContentProps {
  column: ReportColumn;
}

export const HeaderContent: React.FC<HeaderContentProps> = ({ column }) => {
  const isDraft = !column.id || column.id === -999;
  const { selectedColumn } = useReportContext();
  const isSelected = selectedColumn?.id === column.id;

  return (
    <>
      <HeaderIcon
        columnType={column.column_type}
        hasError={!!column.errors}
        isSelected={isSelected}
        isDraft={isDraft}
      />
      <span className={cn(column.errors ? "text-red-500" : "text-gray-500")}>{column.name}</span>
    </>
  );
};
